import React from 'react';
import {Button, Link} from "@material-ui/core";
import imgc2 from "../assets/401_error_unauthorized.svg";
import Copyright from "../common/Copyright";
import {useHistory} from 'react-router-dom';

export default function UnauthorizedPage() {
    const history = useHistory();
    const error = localStorage.getItem('authError') || 'Your account is inactive or deleted';


    const handleReturnHome = () => {
        localStorage.removeItem('authError');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Also clear hijack tokens
        localStorage.removeItem('hijackToken');
        localStorage.removeItem('hijackUserObj');
        localStorage.removeItem('hijackUser');
        history.push('/sign-in');
    };

    return (
        <div className="signin-container">
            <div className="signin-content">
                <div className="signin-header">
                    <a href="https://ezrespond.com/">
                        <img src={imgc2} alt="Unauthorized"
                             className="signin-logo"/>
                    </a>
                    <p>{error}</p>
                    <p> Please contact to administrator <br/> <Link
                        href="mailto:support@ezcloudllc.com">support@ezcloudllc.com</Link>
                    </p>

                </div>
                <div className="signin-auth">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleReturnHome}
                        style={{
                            marginTop: '20px',
                            padding: '10px 20px',
                            cursor: 'pointer'
                        }}
                    >
                        Return to Sign In
                    </Button>
                    <div className="signin-privacy">
                        <p>
                            <Copyright/>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
